/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KeycloakToken
 */
export interface KeycloakToken {
    /**
     * 
     * @type {string}
     * @memberof KeycloakToken
     */
    accessToken?: string;
    /**
     * 
     * @type {string}
     * @memberof KeycloakToken
     */
    expiresIn?: string;
    /**
     * 
     * @type {string}
     * @memberof KeycloakToken
     */
    refreshToken?: string;
    /**
     * 
     * @type {string}
     * @memberof KeycloakToken
     */
    refreshExpiresIn?: string;
    /**
     * 
     * @type {string}
     * @memberof KeycloakToken
     */
    idToken?: string;
}

/**
 * Check if a given object implements the KeycloakToken interface.
 */
export function instanceOfKeycloakToken(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function KeycloakTokenFromJSON(json: any): KeycloakToken {
    return KeycloakTokenFromJSONTyped(json, false);
}

export function KeycloakTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): KeycloakToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accessToken': !exists(json, 'accessToken') ? undefined : json['accessToken'],
        'expiresIn': !exists(json, 'expiresIn') ? undefined : json['expiresIn'],
        'refreshToken': !exists(json, 'refreshToken') ? undefined : json['refreshToken'],
        'refreshExpiresIn': !exists(json, 'refreshExpiresIn') ? undefined : json['refreshExpiresIn'],
        'idToken': !exists(json, 'idToken') ? undefined : json['idToken'],
    };
}

export function KeycloakTokenToJSON(value?: KeycloakToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accessToken': value.accessToken,
        'expiresIn': value.expiresIn,
        'refreshToken': value.refreshToken,
        'refreshExpiresIn': value.refreshExpiresIn,
        'idToken': value.idToken,
    };
}

